import { render, staticRenderFns } from "./MarketingChannelChart.vue?vue&type=template&id=408fc2be"
import script from "./MarketingChannelChart.vue?vue&type=script&lang=js"
export * from "./MarketingChannelChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports